import React from 'react'
import createSvgIcon from 'client/icons/createSvgIcon'

export default createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M15.2 2l1.3.3C19.1 3 21 5.4 21 8.2V15c0 .6-.4 1-1 1h-4v5c0 .6-.4 1-1 1s-1-.4-1-1V3c0-.3.1-.6.3-.8.3-.2.6-.3.9-.2zm.8 12h3V8.2c0-1.9-1.2-3.4-3-3.9V14zM9 3c0-.6.4-1 1-1s1 .4 1 1v8c0 .6-.4 1-1 1H8v9c0 .6-.4 1-1 1s-1-.4-1-1v-9H4c-.6 0-1-.4-1-1V3c0-.6.4-1 1-1s1 .4 1 1v7h1V3c0-.6.4-1 1-1s1 .4 1 1v7h1V3z"
  />,
  'Restaurant'
)
